import { render } from "./ModifyFriezeComponent.vue?vue&type=template&id=2d8f7ad0&scoped=true"
import script from "./ModifyFriezeComponent.vue?vue&type=script&lang=js"
export * from "./ModifyFriezeComponent.vue?vue&type=script&lang=js"

import "./ModifyFriezeComponent.vue?vue&type=style&index=0&id=2d8f7ad0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8f7ad0"]])

export default __exports__